import { connect } from 'react-redux'
import StompunktError from './StompunktError'
import { loadHeavyStompunkter } from '../../actionCreators'

const mapStateToProps = (state, ownProps) => ({});

const mapDispatchToProps = (dispatch, ownProps) => ({
  onRetryClick: () => dispatch(loadHeavyStompunkter([ownProps.id]))
});

export default connect(mapStateToProps, mapDispatchToProps)(StompunktError);


// WEBPACK FOOTER //
// ./src/components/Stompunkt/StompunktErrorContainer.js